(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-variants"] && !Shopify.designMode) return;
  try {
    const display = document.querySelector('.option-name');
const url = window.location.href.toLowerCase();

// All color buttons
const colorButtons = document.querySelectorAll('.btn-color');

// Check URL → match a color name
let matchedColor = null;

colorButtons.forEach(button => {
  const colorName = button.getAttribute('data-color-name').toLowerCase();
  
  // If URL includes color name → pick this as selected
  if (url.includes(colorName)) {
  matchedColor = colorName;
  display.textContent = button.getAttribute('data-color-name');
  localStorage.setItem('selectedColor', button.getAttribute('data-color-name'));

  setSelectedButton(button); // <-- Add this
}

});

// If no match found from URL → restore saved color
if (!matchedColor) {
  const savedColor = localStorage.getItem('selectedColor');
  if (savedColor) {
    display.textContent = savedColor;

    const savedButton = [...colorButtons].find(
      btn => btn.getAttribute('data-color-name') === savedColor
    );

    setSelectedButton(savedButton); // <-- Add this
  }
}


// Handle user clicking colors
colorButtons.forEach(button => {
  button.addEventListener('click', function () {
  const colorName = this.getAttribute('data-color-name');
  display.textContent = colorName;
  localStorage.setItem('selectedColor', colorName);

  setSelectedButton(this); // <-- Add this
});

});

function setSelectedButton(button) {
  // Remove selected class from all buttons
  colorButtons.forEach(btn => btn.classList.remove('selected'));

  // Add to the active one
  if (button) {
    button.classList.add('selected');
  }
}
  } catch(e) { console.error(e); }
})();

})();
